// import {
    
// } from '../../../../common/api';

import { loadState } from '../../localstorage';
import Vue from 'vue';
import _ from 'lodash';
  
const persistedState = loadState() || {};
  
const state = persistedState.activity_class_selection || {
  activity_classes_by_ids: {},
  activity_student_ids: null,
  is_class_loading: false
}

const getters = {

}

const mutations = {
  SET_CLASS(state, clazz) {
    Vue.set(state.activity_classes_by_ids, clazz.id, clazz);
  },
  SET_ACTIVITY_STUDENTS(state, student_ids) {
	state.activity_student_ids = student_ids;
  },
  SET_CLASS_LOADING(state, is_loading) {
	state.is_class_loading = is_loading;
  },
  INIT_ACTIVITY_CLASSES(state) {
    state.activity_classes_by_ids = {};
  }
}

const actions = {
  /***
   * add/update activity_classes_by_ids with selected status
   * @param classId - the id of the class we want to select/unselect it and its all students.
   * @param checked - if set true, we make class and it's studnets to be selected with checked mark, otherwise make them to be unselected
   * @returns {void}
   */
  async selectClass({commit, dispatch}, { classId, checked }) {
    let clazz = { id: classId };
    if (state.activity_classes_by_ids[classId]) {
      clazz = _.cloneDeep(state.activity_classes_by_ids[classId]);
    }

    clazz.checked = checked;
    if (checked) {
      const fullClassObj = await dispatch('classes/getClass', { classId, withStudents: true }, {root: true});
      let students_list = [];
      if (fullClassObj.students_list) {
        students_list = fullClassObj.students_list;
      }
      clazz.selected_student_ids = students_list.map(student => student.id);
    } else {
      clazz.selected_student_ids = [];
    }

    commit('SET_CLASS', clazz);
  },

  /***
   * Select/unselect student for class
   * @param classId - the class id to select students inside it
   * @param studentId - the student id that should be selected/unselected with checked mark
   * @returns {void}
   */
  async selectClassStudent({ commit }, { classId, studentId, checked }) {
    let clazz = { id: classId };
    if (state.activity_classes_by_ids[classId]) {
      clazz = _.cloneDeep(state.activity_classes_by_ids[classId]);
    }

    let selectedStudentIds = clazz.selected_student_ids || [];
    if (checked) {
      if (!selectedStudentIds.includes(studId => studId === studentId)) {
        selectedStudentIds.push(studentId);
      }
    } else {
      selectedStudentIds = selectedStudentIds.filter(studId => studId !== studentId);
    }
    clazz.selected_student_ids = selectedStudentIds;

    commit('SET_CLASS', clazz);
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
  
